// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Field__Component[data-v-0c9f5a06] {\n  direction: ltr;\n  text-align: right;\n}\n.Field__Component.right[data-v-0c9f5a06] {\n    text-align: right;\n}\n.Field__Component.left[data-v-0c9f5a06] {\n    text-align: left;\n}\n.Field__Component.center[data-v-0c9f5a06] {\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
